import { isDevServer } from 'utils/checkEnvironment';
import { isTest } from 'utils/node-env-vars';
import { INTEGRATION_FRAME_HEIGHT } from 'utils/constants';

const RECAPTCHA_KEY = '6LctZjMeAAAAADjroKVf8erjHUwXY6RILDUNqGDK';

/*
 * Resolve whether a feature should be enabled in the UI. Disable everything by
 * default on prod. Enable everything by default on dev. Allow overriding with
 * environment variables.
 */

function resolveFeatureFlag(flagName) {
  if (isDevServer(window) || isTest()) {
    return process.env[flagName] || true;
  }
  return process.env[flagName] || false;
}

/*
 * App Config
 */

export const Config = {
  RecaptchaKey: RECAPTCHA_KEY,
  UpscopeApiKey: 'gwkUNZzQbFLjPdNcrYTZWtZB',
  CookieScriptKey: '5071bbdae32bf782cd3b20190f02d59c',
  InlineManualApiKey: '4c1a9c54dfada08aae9adda157a2c602',
  SegmentApiKey: {
    dev: 'CFlL5IU26mqpBa1kiagB654rrPQKV5CP',
    prod: 'PCUONL292CbFJqAzVCse57jCbsM0uWDF',
  },
  LogRocketAppId: 'nsjiqg/gustav-production',
  MapsApiKey: 'AIzaSyBLg5Or18GqLEcmX9R1fvUfBDCejIz96Ko',
  ZapierDisposableEmailKey: '1024275/oi0q8wl',
  IPStackAccessKey: 'dcdbb67d2b15cbf3202704e77108cdbe',
  TrackJsToken: 'b4661870c2164371b781a25b5e05e4a3',
  FirebaseConfig: {
    apiKey: 'AIzaSyCV5mFTbmprSGAbmTY6TwmVxSfN_V8NX_k',
    authDomain: 'gustav-push-notifications.firebaseapp.com',
    databaseURL: 'https://gustav-push-notifications.firebaseio.com',
    projectId: 'gustav-push-notifications',
    storageBucket: 'gustav-push-notifications.appspot.com',
    messagingSenderId: '357973667805',
    appId: '1:357973667805:web:227040fe3a9532a9',
  },
  FirebaseVapidKey:
    'BJ14crqnvxYozqixVdYGcx1GasLNHBl9vc1pjTxtbc9Io9vuryEbq7t_WFSK0m6Q3f9JlIMURmHtog1fWoPIsoE',
  Mapbox: {
    username: 'bengerson',
    style: 'cjyirvris04jl1cqoshdghy7v',
    mobileStyle: 'ckm3lxqeo15jb17pghpq4fo0i',
    AccessToken:
      'pk.eyJ1IjoiYmVuZ2Vyc29uIiwiYSI6ImNqeWcwOHJnaTAyZ3YzbnJ3Zzd5cGlqejcifQ.-WFvS9x1LaCmU2Dm9qyBTg',
  },
  Bullhorn: {
    oauth: {
      url: 'https://auth.bullhornstaffing.com/oauth/authorize',
      clientId: '0b51ba02-e5f2-4094-b335-bb63a5efc031',
    },
  },
  Chargebee: {
    dev: {
      site: 'hellogustav-test',
      publishableKey: 'test_ta9cdcdY6tXWOigm7Ncd8PWEMtqRFCBeiJ6',
    },
    prod: {
      site: 'hellogustav',
      publishableKey: 'live_ETAQQTl9yUVlokrcdcdJ7cdZLwrUUS7rohU',
    },
  },
  Google: {
    oauth: {
      url: 'https://accounts.google.com/o/oauth2/auth',
      clientId:
        '778179433832-dltu23tk5utv2ggfeua5c5te82mefe7o.apps.googleusercontent.com',
    },
  },
  Azure: {
    oauth: {
      url:
        'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
      dev: { clientId: '47b7d9df-5f16-4dec-893e-e23ad16f4787' },
      prod: { clientId: '017a8d31-cbbe-4d72-b9b2-5716326d3335' },
    },
  },
  Salesforce: {
    oauth: {
      url: 'https://login.salesforce.com/services/oauth2/authorize',
    },
  },
  // Feature flags below
  CandidatesEnabled: resolveFeatureFlag('CANDIDATES_ENABLED'),
  WorkOrdersEnabled: resolveFeatureFlag('WORK_ORDERS_ENABLED'),
  IntegrationFrameHeight: INTEGRATION_FRAME_HEIGHT,
};
